import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { noop } from '../propTypes';
import LoadingComponent from './../LoadingComponent';

function InviteComponent({
    onClick,
    buttonText,
    companyName,
    title,
    invitee,
    noData,
    isLoading,
    onLater,
    isAccepted,
    onContinue,
    error,
}) {
    if (isLoading) {
        return <LoadingComponent />;
    }
    return (
        <div className="welcomeCard">
            {noData ? (
                <div className="card customCard mx-auto p-4 cardShadow">
                    <div className="row justify-content-center">
                        {error || 'Invalid invite token.'}
                    </div>
                </div>
            ) : (
                <div className="card customCard mx-auto p-4 cardShadow">
                    {isAccepted ? (
                        <Fragment>
                            <h2 className="heading bold f_24">
                                <span
                                    style={{
                                        fontSize: 40,
                                        marginRight: 14,
                                        marginTop: 5,
                                    }}
                                >
                                    &#127881;
                                </span>{' '}
                                Congratulations!
                            </h2>
                            <div className="card-body p-0 f_16">
                                You&lsquo;ve successfully joined{' '}
                                <b>{companyName}</b> as <b>{title}</b>, you can
                                now continue to use the platform with your new
                                role
                            </div>
                            <button
                                onClick={onContinue}
                                className="btn btn-primary btn-block btn-getstarted"
                            >
                                Continue
                            </button>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <div className="card-body p-0 f_24">
                                You&lsquo;ve been invited to{' '}
                                <b>{companyName}</b> as <b>{title}</b>
                                <br />
                                <span className="invitedby">By {invitee}</span>
                            </div>
                            {buttonText && buttonText.length ? (
                                <button
                                    onClick={onClick}
                                    className="btn btn-primary btn-block btn-getstarted"
                                >
                                    {buttonText}
                                </button>
                            ) : null}
                            <button
                                onClick={onLater}
                                className="btn btn-primary btn-block btn-later"
                            >
                                Later
                            </button>
                        </Fragment>
                    )}
                    {/* <Fragment/>} */}
                </div>
            )}
        </div>
    );
}

InviteComponent.propTypes = {
    companyName: PropTypes.string,
    title: PropTypes.string,
    invitee: PropTypes.string,
    onClick: PropTypes.func,
    buttonText: PropTypes.string,
    noData: PropTypes.bool,
    isLoading: PropTypes.bool,
    onLater: PropTypes.func,
    onContinue: PropTypes.func,
    isAccepted: PropTypes.bool,
    error: PropTypes.string,
};

InviteComponent.defaultProps = {
    companyName: null,
    noData: null,
    title: null,
    invitee: null,
    onClick: noop,
    onLater: noop,
    buttonText: null,
    isLoading: true,
    onContinue: noop,
    isAccepted: null,
    error: null,
};

export default InviteComponent;
